import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'
import 'whatwg-fetch'

var api = document.getElementById('app').getAttribute('data-api')

export default {

	busy: false,
	controller: false,
	signal: false,

	isBusy: function() {

		return this.busy

	},

	request: function(url, params) {

		params = params || {}

		if (this.busy && !params.silent) {

			this.controller.abort()

		}

		this.controller = new AbortController()
		this.signal = this.controller.signal

		this.busy = true

		url = api + url + '.json'

		var self = this

		return new Promise(function(resolve, reject) {

			window.fetch(url, {
				synchronous: false,
				method: 'POST',
				headers: {
					'content-type': 'application/json',
					'x-requested-with': 'xmlhttprequest'
				},
				credentials: 'include',
				signal: self.signal,
				body: JSON.stringify(params)
			}).then(function(response) {

				self.busy = false

				if (!response.ok) {

					response.json().then(function(json) {

						reject(json.data)

					}, function(error) {

						reject(error)

					})

				} else {

					return response.json().then(function(json) {

						resolve(json.data)

					}, function(error) {

						reject(error)

					})

				}

			}, function(error) {

				reject(error)

			})

		})

	}

}